import { initializeFreshworksChat } from '@app/freshdesk/chat_widget_setup'

const launchChat = () => {
  window.fcWidget.open()
  if (!window.fcWidget.isLoaded()) {
    Silverfin.Spinner.start()
  }

  window.FreshworksWidget('close')
}

const effectiveInitializeFreshworksChat = (onLoadCallback) => () => {
  if (document.body.dataset.freshdeskChatInNewWindow === 'true') return

  if (document.body.dataset.freshdeskEnabled === 'true') {
    if (!window.fcWidget?.isInitialized()) {
      initializeFreshworksChat(onLoadCallback)
    } else {
      if (onLoadCallback && typeof onLoadCallback === 'function') {
        onLoadCallback()
      }
    }
  }
}

const reguralLaunchChat = (e) => {
  e.preventDefault()

  launchChat()
}

const eagerLaunchChat = (e) => {
  e.preventDefault()

  effectiveInitializeFreshworksChat(launchChat)()
}

$(document).on('click', "[data-behavior='sf-freshdesk-help-launcher']", (e) => {
  e.preventDefault()

  window.FreshworksWidget('open')

  if (window.fcWidget) {
    window.fcWidget.close()
  }
})

$(document).on(
  'click',
  "[data-behavior='sf-freshdesk-chat-launcher-new-window']",
  (e) => {
    e.preventDefault()

    const url = e.currentTarget.href
    window.open(
      url,
      '_blank',
      'location=no,height=570,width=520,toolbar=no,manubar=no,scrollbars=yes,status=yes'
    )
  }
)

$(document).on(
  'click',
  "[data-behavior='sf-freshdesk-chat-launcher']",
  reguralLaunchChat
)

$(document).on(
  'click',
  "[data-behavior='sf-freshdesk-chat-launcher-eager']",
  eagerLaunchChat
)

$(document).on(
  'click',
  "[data-behavior='sf-help-menu']",
  effectiveInitializeFreshworksChat()
)
